import { getIn } from "formik";
import ToggleableCheckbox from "../ToggleableCheckbox";
import { EasyFieldProps } from "./EasyForm";

interface EasyCheckboxProps {
    editMode: boolean
    fieldName: string
    disabled: boolean
    render?: (checked?: boolean) => JSX.Element
    disabledTooltip?: string
}

export default function EasyCheckbox(props: EasyFieldProps & EasyCheckboxProps): JSX.Element {
    const checked = getIn(props.values, props.fieldName);
    return (

        <ToggleableCheckbox
            editMode={props.editMode}
            id={props.fieldName}
            name={props.fieldName}
            render={props.render}
            checked={checked}
            indeterminate={checked === undefined}
            disabled={props.disabled}
            onChange={(_ev, checked) => props.setFieldValue(props.fieldName, checked)}
            disabledTooltip={props.disabledTooltip}
        />

    )
}